export default __webpack_public_path__ + "static/media/landslide.8dbf834b.svg";